import React, { useEffect, useRef } from 'react'
import { Text } from 'react-native'
import { useTheme } from 'styled-components/native'
import Modal from '../common/Modal'
import { H3 } from '../common/Text'
import Button from '../common/Button'
import useTranslation from '../../hooks/useTranslation'
import TextInput from '../common/TextInput'
import { Flex } from '../FlexBox'

interface LinkModalProps {
  isOpen: boolean
  onClose: () => void
  url: string
  onUrlChange: (string) => void
  onSubmit: () => void
  /** Shown under the field, e.g. when the link can't be used */
  error?: string | null
  /**
   * Put the cursor in the field when the dialog opens, and let Enter submit.
   * Off by default, so existing callers are unchanged.
   */
  focusOnOpen?: boolean
}

const LinkModal = ({
  isOpen,
  onClose,
  url,
  onUrlChange,
  onSubmit,
  error = null,
  focusOnOpen = false
}: LinkModalProps) => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const input = useRef<any>(null)

  useEffect(() => {
    if (!isOpen || !focusOnOpen) return
    // After the modal has mounted its contents
    const timer = setTimeout(() => input.current?.focus(), 0)
    return () => clearTimeout(timer)
  }, [isOpen, focusOnOpen])

  return (
    <Modal open={isOpen} close={onClose}>
      <H3 styles={{ paddingBottom: 10 }}>{t('richTextEditor:linkPrompt')}</H3>
      <TextInput
        ref={input}
        placeholder="https://google.com"
        value={url}
        onChangeText={onUrlChange}
        hasError={!!error}
        // Passed through to the input: submit on Enter (only when
        // focusOnOpen, as above)
        {...((focusOnOpen ? { onSubmitEditing: onSubmit } : {}) as any)}
      />
      {!!error && (
        <Text style={{ marginTop: 6, fontSize: 13, color: colors.danger }}>
          {error}
        </Text>
      )}

      <Flex
        flexDirection="row"
        justifyContent="flex-end"
        style={{ paddingTop: 10 }}
      >
        <Button label="Cancel" onPress={onClose} style={{ marginRight: 10 }} />
        <Button label="Submit" onPress={onSubmit} />
      </Flex>
    </Modal>
  )
}

export default LinkModal
